import { GetProps, styled, XStack, YStack } from 'tamagui';

export const Row = styled(XStack, {
  name: 'Row',
  gap: '$2',
  justifyContent: 'flex-start',
  alignItems: 'flex-start'
});

export const Column = styled(YStack, {
  name: 'Column',
  display: 'flex'
});

export type RowProps = GetProps<typeof Row>;
